const languages = [
    "HTML",
    "CSS",
    "React",
    "Next.js",
    "Node",
    "MongoDB",
    "Bootstrap",
    "Material UI",
    "Sass",
    "React Native",
    "Vue.js",
    "TailwindCSS",
    "Express.js",
    "NativeBase",
  ];
  
  export default languages;